import { BaseService } from '@/modules/Core/services/BaseService'
import type { ICitaAnexo } from '@/modules/Asistencial/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'

export class AnexoService extends BaseService<ICitaAnexo> {
  constructor () {
    super({
      baseUrl: 'scheduling/annexes/'
    })
  }

  async getAnexe (id: number): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .get<IResponseApi<unknown>>(`/get-annexe/${id}`)
      .catch(this.errorHandle)
  }

  async postTramitarConAnexos (form: FormData): Promise<AxiosResponse<IResponseApi<ICitaAnexo>>> {
    return this.postFile('/tramitar-con-anexos', form)
  }

  async putRelaciones (cianId: number, form: FormData): Promise<AxiosResponse<IResponseApi<ICitaAnexo>>> {
    return this.putFile(`/relaciones/${cianId}`, form)
  }

  async deleteAnexosLimpiar (cittId: number, body?: { motivo: string }): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http
      .delete<IResponseApi<unknown>>(`/anexos-limpiar/${cittId}`, { data: body })
      .catch(this.errorHandle)
  }
}